import { combineReducers } from '@reduxjs/toolkit';
import errorsSlice from '@state/features/errors.slice';
import loadingSlice from '@state/features/loading.slice';
import productSaga from '@state/features/product.saga';
import productSlice from '@state/features/product.slice';
import searchSlice from '@state/features/search.slice';
import redirectSlice from '@state/features/redirect.slice';
import { all, fork } from 'redux-saga/effects';
import listingSaga from './listing.saga';
export const rootReducer = combineReducers({
    product: productSlice.reducer,
    search: searchSlice.reducer,
    errors: errorsSlice.reducer,
    loading: loadingSlice.reducer,
    redirect: redirectSlice.reducer,
});
export function* rootSaga() {
    yield all([fork(productSaga)]);
    yield all([fork(listingSaga)]);
}
